export default __webpack_public_path__ + "static/media/speaker-overlay.22ee4d50.png";